import React from "react"

import "./src/styles/global.scss"

import { RootLayout } from '/src/components/structures/'

export const wrapRootElement = ({ element, props }) => {
	return <RootLayout {...props}>{element}</RootLayout>
}
